import React from "react";
import { AddIcon } from "../icons/AddIcon";

export function AddButton(props: AddButtonProps) {
    const { label, onClick } = props;

    const handleAddButtonClicked = () => {
        onClick();
    };

    return (
        <div className="add_button" onClick={handleAddButtonClicked}>
            <div className="add_button__body">
                <div className="add_button__icon">
                    <AddIcon/>
                </div>
                <span className="add_button__text">{label}</span>
            </div>
        </div>
    );
}

export type AddButtonProps = {
    label: string,
    onClick: () => void,
};
